import FareLock from './components/ConfirmOption/ConfirmOption.css';
import DescriptionBlock from './components/DescriptionBlock/DescriptionBlock.css';
import SwitchBlock from './components/SwitchBlock/SwitchBlock.css';
export default {
    FareLock,
    DescriptionBlock,
    SwitchBlock
};
